import React, { ReactNode } from 'react';
import Meta, { CardMetaProps as CardMetaCopyProps } from 'antd/lib/card/Meta';

export type CardMetaProps = CardMetaCopyProps & {
  children?: ReactNode;
};

const ProCardMeta: React.FC<CardMetaProps> = (props) => {
  const { children, ...resProps } = props;

  return <Meta {...resProps}>{children}</Meta>;
};

export default ProCardMeta;
